import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import FeedbackList from "views/pages/feedback/FeedbackList";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const Feedback = () => {
  const [feedbackList, setFeedbackList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();
  useEffect(() => {
    const feedback = Utility.getUserData({
      datastore: userData,
      activePath: location.pathname,
    });
    if (userData.data.user.role === "2") {
      setPermission(feedback[1]);
    } else {
      setPermission({});
    }
    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteFeedback)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = feedbackList.filter((o) => o.id !== id);
            setFeedbackList(filter);
            fetchFeedbackList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  useEffect(() => {
    fetchFeedbackList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, pageNumber]);

  const fetchFeedbackList = () => {
    Loader.isLoading(true);
    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
    };
    APICall("post", payload, EndPoints.getFeedbackList)
      .then((response) => {
        const { result, totalCount } = response.data.data;
        if (response.status === 200 && result) {
          setFeedbackList(result);
          setTotalRecord(totalCount);
        } else {
          setFeedbackList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const handleConfirmChange = (selectId) => {
    Loader.isLoading(true);
    const updatedData = feedbackList.map((x) => {
      if (x.id === selectId) {
        const payload = {
          id: selectId,
          status: x.status === 0 ? 1 : 0,
        };
        APICall("post", payload, EndPoints.changeFeedbackStatus)
          .then((response) => {
            const { message, isError } = response.data;
            if (response.status === 200 && !isError) {
              toast.success(message);
            }
            Loader.isLoading(false);
          })
          .catch((error) => {
            Loader.isLoading(false);
            return error;
          });

        return {
          ...x,
          status: x.status === 0 ? 1 : 0,
        };
      }
      return x;
    });
    setFeedbackList(updatedData);
  };
  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Feedback
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <FeedbackList
            feedbackList={feedbackList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            handleConfirmChange={handleConfirmChange}
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Feedback;
